import React from "react";
import "../../sass/ui/button.scss";

export const Button = ({ children, variant = "default", ...props }) => (
  <button className={`custom-button ${variant}`} {...props}>{children}</button>
);
